import { render } from "./placeholderImg.vue?vue&type=template&id=69fbbbb1&ts=true"
import script from "./placeholderImg.vue?vue&type=script&lang=ts"
export * from "./placeholderImg.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__